<div class="google-map-wrapper" [style.height]="height" [style.width]="width">
  <google-map
    #mapRef
    [height]="height"
    [width]="width"
    [center]="center"
    [zoom]="zoom"
    [options]="options"
  >
    <!-- Future: custom polygons/overlays go here -->
  </google-map>
</div>
